import { Col, ColorPicker, Layout, Row, Space } from "antd";
import style from "./Header.module.scss";
import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  ResponsiveNotification,
} from ".";
import { useTheme } from "shared/hooks/useThemeContent";
const { Header } = Layout;

const _Header = () => {

  const { colors, setTheme } = useTheme();

  useEffect(() => {}, [colors]);
  const loggedIN = !!localStorage.getItem("jwt");


  return (
    <div className={`${style.antLayoutHeader}`}>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify={"space-between"}
        align={"middle"}
      >
        <Col xs={24} sm={24} md={24} lg={24} xl={24} className={"mb-4"}>
          <Row
              justify={"space-between"}
              align={"top"}
              className={style.responsiveHeader}
          >
            <img width={65} src={require("assets/Logo/typographyBlue.png")}/>
            <ResponsiveNotification/>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default _Header;
